// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationPermissionRequired_container__1ofWD"};